import React from 'react'
import moment from 'moment'
import Calendar from '@/components/calendar/Calendar'
import {
  IExistingScaleInterval,
  ICellConfig,
  ECellColor,
  getTimeslotColor,
  EBadgeType,
} from '@/components/calendar/calendarTypes'
import utils from '@/components/calendar/utils'
import { IFullSchema } from '@/store/apis/schemas'
import { IValue } from '@/components/dropDown/DropDown'

interface IPreviewSchemaProps {
  isLoading: boolean
  firstDay: moment.Moment
  lastDay: moment.Moment
  schemaData: IFullSchema
  placeDropDownData: IValue[]
  setFirstDay(newFirstDay: moment.Moment): void
}

const PreviewSchema: React.FC<IPreviewSchemaProps> = ({
  isLoading,
  firstDay,
  lastDay,
  schemaData,
  placeDropDownData,
  setFirstDay,
}) => {
  const [timeslots, setTimeslots] = React.useState<IExistingScaleInterval[]>([])
  const [underlyingCellConfigs, setUnderlyingCellConfigs] = React.useState<
    ICellConfig[]
  >([])

  React.useEffect(() => {
    const existingCells: ICellConfig[] = []
    schemaData.schema.timeslots.map((timeslot) => {
      const isInsideInterval = moment(timeslot.startTimestamp).isBetween(
        firstDay,
        lastDay,
      )
      if (isInsideInterval) {
        const intervals = utils.getIntervalsByDuration(
          30,
          moment(timeslot.startTimestamp),
          moment(timeslot.endTimestamp),
        )
        intervals.map((interval) => {
          existingCells.push({
            startTimestamp: interval.start,
            color: getTimeslotColor(timeslot),
            badge: timeslot.comment && {
              type: EBadgeType.Scene,
              contents: [
                {
                  label: timeslot.comment,
                  comment: '',
                },
              ],
            },
          })
        })
      }
    })

    // Scenes timeslots
    const existing: IExistingScaleInterval[] = []
    schemaData.scenes.map((scene): void => {
      scene.timeslots.map((timeslot) => {
        existing.push({
          id: timeslot.id,
          start: moment(timeslot.startTimestamp),
          end: moment(timeslot.endTimestamp),
          color: ECellColor.Scene,
          comment: scene.scene.name,
          placeId: timeslot.placeId,
        })
      })
    })

    // Scenes groups timeslots
    schemaData.sceneGroups.map((sceneGroup): void => {
      sceneGroup.timeslots.map((timeslot) => {
        existing.push({
          id: timeslot.id,
          start: moment(timeslot.startTimestamp),
          end: moment(timeslot.endTimestamp),
          color: ECellColor.Scene,
          comment: sceneGroup.sceneGroup.name,
          placeId: timeslot.placeId,
        })
      })
    })
    setUnderlyingCellConfigs(existingCells)
    setTimeslots(existing)
  }, [schemaData, firstDay, lastDay])

  return (
    <Calendar
      preview={true}
      isLoading={isLoading}
      firstDay={firstDay ?? moment()}
      onFirstDayUpdate={(newFirstDay) => setFirstDay(newFirstDay)}
      minDay={
        schemaData
          ? moment(new Date(schemaData.schema.schema.startDate))
          : undefined
      }
      maxDay={
        schemaData
          ? moment(new Date(schemaData.schema.schema.endDate))
          : undefined
      }
      createColor={ECellColor.Scene}
      selectedIntervals={timeslots}
      allowOverlap
      showPlaceOnEvent
      underlyingCellConfigs={underlyingCellConfigs}
      placeData={placeDropDownData}
      onIntervalSelect={() => {}}
      onIntervalUpdate={() => {}}
      onIntervalsRemove={() => {}}
      calendarDayComment={
        schemaData
          ? schemaData.schema.days.map((day) => ({
              date: new Date(day.date),
              comment: day.comment,
            }))
          : []
      }
    />
  )
}

export default PreviewSchema
